module.exports = __webpack_public_path__ + "static/media/Tony-abou jawad.5ddf11cf.png";